import { QUERY_KEYS } from 'api/query-keys';
import _ from 'lodash';
import { projectService } from 'ogp/services';
import { useQuery } from 'react-query';

export const useGetProjectCheckoutInboxFilters = () => {
  const queryFn = async () => await projectService.getProjectCheckoutInboxFilters();

  return useQuery(QUERY_KEYS.checkoutInboxProjectsFilters(), {
    queryFn,
    select: (data) => ({
      ...data,
      branchOffices: _.sortBy(data.branchOffices, (branchOffice) =>
        branchOffice.name.toLowerCase()
      ),
    }),
  });
};
